/* A numbered legal section: icon tile, Garamond heading and body content. */
export default function SectionBlock({ id, number, icon: Icon, title, children }) {
  return (
    <section id={id} className="lc-section" aria-labelledby={`${id}-title`}>
      <div className="lc-section-head">
        {Icon && <span className="lc-icon"><Icon size={20} aria-hidden="true" /></span>}
        <div>
          <span className="lc-num">Section {String(number).padStart(2, "0")}</span>
          <h2 id={`${id}-title`}>{title}</h2>
        </div>
      </div>
      {children}
    </section>
  );
}
